import { render } from "./SelecionarFormaPagamento.vue?vue&type=template&id=7428eb4c&scoped=true&ts=true"
import script from "./SelecionarFormaPagamento.vue?vue&type=script&lang=ts"
export * from "./SelecionarFormaPagamento.vue?vue&type=script&lang=ts"

import "./SelecionarFormaPagamento.vue?vue&type=style&index=0&id=7428eb4c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7428eb4c"]])

export default __exports__